import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20background%20with%20warm%20coral%20and%20amber%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20minimal%20design%2C%20soft%20layered%20textures%2C%20energetic%20yet%20sophisticated%20atmosphere%2C%20digital%20art%20with%20smooth%20color%20transitions%2C%20no%20text%2C%20clean%20aesthetic%20perfect%20for%20entertainment%20news%20platform%20hero%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="今日看料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full w-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex -space-x-3">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-background-50 overflow-hidden bg-accent-300 flex items-center justify-center">
              <i className="ri-user-line text-background-50 text-xl"></i>
            </div>
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-background-50 overflow-hidden bg-primary-300 flex items-center justify-center">
              <i className="ri-user-line text-background-50 text-xl"></i>
            </div>
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-background-50 overflow-hidden bg-secondary-300 flex items-center justify-center">
              <i className="ri-user-line text-background-50 text-xl"></i>
            </div>
          </div>
          <span className="text-background-50/80 text-sm font-medium">吃瓜群众已就位 · 实时追踪中</span>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-2xl">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              吃瓜一线
              <br />
              <span className="font-light">热点追踪站</span>
            </h1>
            <Link
              to="/category/chigua-qianxian"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50 hover:bg-background-100 transition-colors group whitespace-nowrap cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-950">立即吃瓜</span>
              <div className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </div>
            </Link>
          </div>

          <div className="hidden lg:block max-w-sm">
            <p className="text-background-50/90 text-sm leading-relaxed">
              今日看料网入口聚合——覆盖网红爆料、娱乐圈八卦、PP料今日最新价格、黑料今日等实时内容
              <br />
              吃瓜群众的一线热点追踪站
            </p>
          </div>
        </div>

        <div className="mt-6 md:mt-8 flex flex-wrap gap-2">
          {hotTags.slice(0, 6).map((tag) => (
            <Link
              key={tag}
              to={`/category/chigua-qianxian`}
              className="px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
          <div className="w-1 h-2 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}